import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import API from "@beardeddevops/react.api";
import Objects from "../Objects";
import UserRoles from "constants/UserRoles";
import Select from "react-select";
import Button from "@material-ui/core/Button";

export default class Videos extends Framework.Components.Collection {

	constructor(props) {
		let model = new API.BuildClass(Types.Videos._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_COLLECTION';
		this.state.selectedCategory = null;
		this.state.categories = [];
		this.state.sub_categories = [];
		this.state.real_data = [];
		localStorage.setItem('table-preferences-Videos', JSON.stringify({}));
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getCategories();

		if (window.location.href.includes('?')) {
			if (window.location.href.includes('category')) {
				let presetCategory = window.location.href.split('category=')[1];
				let presetSubCategory = null;
				if (presetCategory.includes('|')) {
					presetCategory = this.state.categories?.find((item) => item.name === presetCategory.split('|')[0]);
					await this.getSubCategories(presetCategory.pkey)
					presetSubCategory = this.state.sub_categories?.find((item) => item.name === window.location.href.split('|')[1]);
				} else {
					presetCategory = this.state.categories?.find((item) => item.name === presetCategory);
				}
				if (presetCategory) {
					this.setState({selectedCategory: {value: presetCategory.pkey, label: presetCategory.name}})
				}
				if (presetSubCategory) {
					this.setState({selectedSubCategory: {value: presetSubCategory.pkey, label: presetSubCategory.name}})
				}
			} else {
				const presetVideo = window.location.href.split('video=')[1];
				if (presetVideo) {
					this.state.selectedCategory = {value: presetVideo, label: 'Preselected Video'}
				}
			}
		}

		await this.fetchData();
	}

	fetchData = async (state) => {
		this.state.real_data = [];
		this.state.sorted = [];
		this.state.page = 0;
		this.state.filter = {};
		this.state.limit = 200;
		this.limit = 200;
		this.request = 'GET_COLLECTION';
		if (this.state.selectedCategory) {
			this.state.filter.filterCategory = this.state.selectedCategory?.label === 'Preselected Video' ? this.state.selectedCategory.value + '_video' : this.state.selectedCategory.value
		}
		if (this.state.selectedSubCategory) {
			this.state.filter.filterSubCategory = this.state.selectedSubCategory ? this.state.selectedSubCategory.value : null;
		}

		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state, ['real_data']);
		}, 100);
	}

	reloadTable = () => {
		this.setState({
			key: Math.random(),
			expanded: {},
		});
		this.fetchData()
	}

	getCategories = async () => {
		let model = new API.BuildClass(Types.Categories._name, API.RequestType.READ_ALL);
		this.data = await model.submit(null, API.RequestType.READ_ALL);
		this.setState({
			categories: this.data.items
		});
	}

	getSubCategories = async (category) => {
		let model = new API.BuildClass(Types.Categories_Subs._name, API.RequestType.READ);
		this.read = 'GET_BY_CATEGORY';
		model.parent = category;
		this.data = await model.submit(null, this.read);
		this.setState({
			sub_categories: this.data.items
		});
	}


	render() {
		return (
			<fieldset>
				<div className={'row'}>
					<div className={'col-4'}>
						<div className={'table-bar'}>
							<div className={'d-flex'}>
								{this.renderSearch('Videos')}
							</div>
						</div>
					</div>
					<div className={'col-4'} style={{zIndex: 999}}>
						<Select
							key={this.state.categories}
							placeholder={"Category Select"}
							isMulti={false}
							isClearable
							value={this.state.selectedCategory}
							onChange={async (value) => {
								await this.setState({
									selectedCategory: value,
									selectedSubCategory: null,
									sub_categories: []
								})
								value && await this.getSubCategories(value.value)
								await this.fetchData(this.state);
							}}
							options={this.state.categories.map(category => {
								return (
									{value: category.pkey, label: category.name})
							})}
							styles={this.styles}
						/>
					</div>
					{this.state.selectedCategory && <div className={'col-4'} style={{zIndex: 999}}>
						<Select
							key={this.state.sub_categories}
							placeholder={"Sub-Category Select"}
							isMulti={false}
							isClearable
							value={this.state.selectedSubCategory}
							onChange={async (value) => {
								await this.setState({selectedSubCategory: value})
								await this.fetchData(this.state);
							}}
							options={this.state.sub_categories.map(category => {
								return (
									{value: category.pkey, label: category.name})
							})}
							styles={this.styles}
						/>
					</div>}
				</div>

				{this.state.real_data.length > 0 ? this.state.real_data.map((category, index) => {
					return category.pkey === 'last' ?  (<div className={'form-group'}>
						<h4 className={'section-title flex-row d-flex align-items-center flex-wrap'}>
							Last 6 Videos Added
						</h4>
						<div className={'row'} key={'category-' + index}>
							{category.videos.map((video, index) => {
								return (
									<div className={'col-lg-4 col-sm-12'}>
										<Objects.Video
											id={video}
											isNew={false}
											editable={this.props.roles.includes(UserRoles.Admin)}
											userRoles={this.props.userRoles}
											afterDelete={this.refreshPage}
											afterSave={() => {this.fetchData(this.state)}}
											collection={true}
										/>
									</div>
								)
							})}
						</div>
					</div>) :
					category.pkey === 'generic' ? (
						<div className={'form-group'}>
							<h4 className={'section-title flex-row d-flex align-items-center flex-wrap'}>
								Generic Videos
							</h4>
							<div className={'row'} key={'category-' + index}>
								{category.videos.map((video, index) => {
									return (
										<div className={'col-lg-4 col-sm-12'}>
											<Objects.Video
												id={video}
												isNew={false}
												editable={this.props.roles.includes(UserRoles.Admin)}
												userRoles={this.props.userRoles}
												afterDelete={this.refreshPage}
												afterSave={() => {this.fetchData(this.state)}}
												collection={true}
											/>
										</div>
									)
								})}
							</div>
						</div>
					) : (
						<>
							{category.videos.length > 0 &&
									<div className={'form-group'}>
										<h4 className={'section-title flex-row d-flex align-items-center flex-wrap'}>
											{category.name} - Generic Videos
											<div className={'justify-content-end'}>
												<Button onClick={async () => {
													const prefix = window.location.href.includes('dev.') ? 'dev.' : window.location.href.includes('beta.') ? 'beta.' : 'app.';
													await navigator.clipboard.writeText(prefix + 'karlstechnology.com/videos?category=' + category.name);
													API.Toast.info('URL Copied', {
														position: API.Toast.POSITION.TOP_RIGHT
													});
												}} color={'primary'} variant={'contained'}>Copy URL</Button>
											</div>
										</h4>
										<div className={'row'} key={'category-' + index}>
											{category.videos.map((video, index) => {
												return (
													<div className={'col-lg-4 col-sm-12'}>
														<Objects.Video
															id={video}
															isNew={false}
															editable={this.props.roles.includes(UserRoles.Admin)}
															userRoles={this.props.userRoles}
															afterDelete={this.refreshPage}
															afterSave={() => {this.fetchData(this.state)}}
															collection={true}
														/>
													</div>
												)
											})}
										</div>
									</div>

							}
							{category.subcategories?.map((subcategory, index) => {
								return (
									<div className={'form-group'}>
										<h4 className={'section-title flex-row d-flex align-items-center flex-wrap'}>
											{category.name} - {subcategory.name} Videos
											<div className={'justify-content-end'}>
												<Button onClick={async () => {
													const prefix = window.location.href.includes('dev.') ? 'dev.' : window.location.href.includes('beta.') ? 'beta.' : 'app.';
													await navigator.clipboard.writeText(prefix + 'karlstechnology.com/videos?category=' + category.name + "|" + subcategory.name);
													API.Toast.info('URL Copied', {
														position: API.Toast.POSITION.TOP_RIGHT
													});
												}} color={'primary'} variant={'contained'}>Copy URL</Button>
											</div>
										</h4>
										<div className={'row'} key={'category-' + index}>
											{subcategory.videos.map((copyable, index) => {
												return (
													<div className={'col-lg-4 col-sm-12'}>
														<Objects.Video
															id={copyable}
															isNew={false}
															editable={this.props.roles.includes(UserRoles.Admin)}
															userRoles={this.props.userRoles}
															afterDelete={this.refreshPage}
															afterSave={() => {this.fetchData(this.state)}}
															collection={true}
														/>
													</div>
												)
											})}
										</div>
									</div>
								)
							})}
						</>
					)
				}) : null}
			</fieldset>
		)
	}

	customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: 32
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: '1px 6px'
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: 4,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 3,
		})
	};

	styles = {
		...this.customStyles, ...{
			container: (provided) => ({
				...provided,
			}),
			control: (provided) => ({
				...provided,
				minHeight: '30px'
			}),
			valueContainer: (provided) => ({
				...provided,
				overflow: 'visible',
				padding: '1px 8px'
			}),
			placeholder: (provided, state) => ({
				...provided,
				position: "absolute", //(state.hasValue && state.selectProps.value.label) &&
				top: -4,
				left: -4,
				marginLeft: 0,
				marginRight: 0,
				fontSize: '1rem',
				color: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'rgba(0, 0, 0, 0.54)',
				transition: "top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
				transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) ? "translate(14px, -6px) scale(0.75) !important" : "translate(14px, 10px) scale(1) !important",
				transformOrigin: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "top left",
				//transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'matrix(0.75, 0, 0, 0.75, 14, -6)',
				backgroundColor: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'white',
				padding: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && '0 8px',
			}),
			multiValue: (provided) => ({
				...provided,
				zIndex: 2
			})
		}
	};

}
